import { useCallback, useMemo } from 'react'
import styled from 'styled-components/macro'
import { Fab } from '@mui/material'
import { PolicyList } from '@tomfxs/permissions-client'
import { EntityJSON, PolicyJSON } from '@tomfxs/permissions-core'
import { useNavigate } from 'react-router-dom'
import { Add } from '@mui/icons-material'
import RouteContainer from 'src/components/App/RouteContainer'

const StyledFab = styled(Fab)`
    position: absolute;
    bottom: 5rem;
    right: 5rem;
`

const LOCAL_STORAGE_FILTER_KEY = 'mp_permissions_filter_entity'
const LOCAL_STORAGE_MODE_KEY = 'mp_permissions_list_mode'

export function PermissionsIndexRoute() {
    const navigate = useNavigate()

    const initialFilter = useMemo(() => {
        const item = localStorage.getItem(LOCAL_STORAGE_FILTER_KEY)
        return item ? JSON.parse(item) : null
    }, [])

    const initialMode = useMemo(() => {
        return (localStorage.getItem(LOCAL_STORAGE_MODE_KEY) ?? 'target') as 'scope' | 'target' | 'actor'
    }, [])

    const onChangeMode = useCallback((mode: string) => {
        localStorage.setItem(LOCAL_STORAGE_MODE_KEY, mode)
    }, [])

    const onChangeFilterEntity = useCallback((entity: EntityJSON) => {
        localStorage.setItem(LOCAL_STORAGE_FILTER_KEY, JSON.stringify(entity))
    }, [])

    const onSelect = useCallback(
        (policy: PolicyJSON) => {
            navigate(policy._id)
        },
        [navigate],
    )

    const onNew = useCallback(() => navigate('/settings/permissions/new'), [navigate])

    return (
        <RouteContainer>
            <PolicyList
                onSelect={onSelect}
                initialMode={initialMode}
                initialFilterEntity={initialFilter}
                onChangeFilterEntity={onChangeFilterEntity}
                onChangeMode={onChangeMode}
            />
            <StyledFab color="primary" onClick={onNew}>
                <Add />
            </StyledFab>
        </RouteContainer>
    )
}
